import Time from 'react-time';
import React from 'react';
import { connect } from 'react-redux';
import { camelizeKeys } from 'humps';
import { selectOrganization } from '../../../../modules/organizations.js';
import { getOrgTermsContent } from '../../../../content/utils.js';
import ProjectIcon from '../../../icons/ProjectIcon.jsx';
import VerticalSeparator from '../../../VerticalSeparator.jsx';
import { LeadIcon } from '../../../icons/LeadIcon.jsx';
import { ClockIcon } from '../../../icons/ClockIcon.jsx';
import RatingLabel from '../../../RatingLabel.jsx';
import { ShowMoreItemsHeader } from '../../../projects/ChangeStrategy/ChangeStrategyOverview/ShowMoreItemsHeader.jsx';
import { HandshakeBlueIcon } from '../../../icons/HandshakeBlueIcon.jsx';
import { ResourcesBlueIcon } from '../../../icons/ResourcesBlueIcon.jsx';
import PortfolioIcon from '../../../icons/PorfolioIcon.jsx';
import { PortfolioInfoLink } from '../../../links/index.jsx';
import ParentPortfolioIcon from '../../../icons/ParentPorfolioIcon.jsx';

const mapStateToProps = (state) => ({
  organization: selectOrganization(state),
});

const ProjectDetailsHeader = ({
  project,
  changeStrategy,
  projectStatuses,
  portfolio,
  isShowStrategyData = false,
  organization,
}) => {
  const archivedStatuses = projectStatuses
    .filter((s) => s.archived)
    .map((s) => s.id);
  return (
    <div className="component component-bg-white">
      <div className="flex" style={{ alignItems: 'flex-start' }}>
        {organization?.hasParentPortfolios ? (
          <React.Fragment>
            <div className="flex header-item">
              <ParentPortfolioIcon />
              <strong className="text-muted m-r-12 m-l-8">
                {getOrgTermsContent('parentPortfolio')}:{' '}
              </strong>
              <strong>
                <strong>{project?.parentPortfolioName || '—'}</strong>
              </strong>
            </div>
            <VerticalSeparator />
          </React.Fragment>
        ) : null}

        <div className="flex header-item">
          <PortfolioIcon />
          <strong className="text-muted m-r-12 m-l-8">
            {getOrgTermsContent('portfolio')}:{' '}
          </strong>
          <strong>
            {portfolio ? (
              portfolio.permissions &&
              camelizeKeys(portfolio.permissions)?.canRead ? (
                <PortfolioInfoLink portfolioId={portfolio.id}>
                  {portfolio.name}
                </PortfolioInfoLink>
              ) : (
                <strong>{portfolio.name}</strong>
              )
            ) : (
              '—'
            )}
          </strong>
        </div>
        <VerticalSeparator />
        <div className="flex header-item">
          <ProjectIcon />
          <strong className="text-muted m-r-12 m-l-8">
            {getOrgTermsContent('project')}:{' '}
          </strong>
          <strong>{project.name}</strong>
        </div>
        <VerticalSeparator />
        <div className="flex header-item">
          <LeadIcon />
          <strong className="text-muted m-l-8">
            {project.owners?.length > 1 ? 'Owner(s):' : 'Owner:'}
          </strong>
        </div>
        <div className="flex header-item">
          {project?.owners?.length ? (
            <ShowMoreItemsHeader
              items={project.owners.map((owner) => ({
                ...owner,
                name: `${owner.firstName} ${owner.lastName}`,
              }))}
              maxShowNumber={2}
            />
          ) : (
            '—'
          )}
        </div>
        <VerticalSeparator />
        <div className="flex header-item">
          <ClockIcon />
          <strong className="text-muted m-r-12 m-l-8">Dates: </strong>
          <strong>
            <Time value={project.startDate} format="M/D/YY" />
          </strong>
          <strong>
            <span>&nbsp;- </span>
            <Time value={project.endDate} format="M/D/YY" />
          </strong>
        </div>
      </div>
      <div className="flex header-row">
        {!isShowStrategyData ? (
          <React.Fragment>
            <div className="flex header-item">
              <strong className="text-muted m-r-12">Impact: </strong>
              <strong>
                <RatingLabel rating={project.impact} reverse />
              </strong>
            </div>
            <VerticalSeparator />
          </React.Fragment>
        ) : null}

        <div className="flex header-item">
          <strong className="text-muted m-r-12">Scope: </strong>
          <strong>
            <RatingLabel rating={project.scope} reverse />
          </strong>
        </div>
        <VerticalSeparator />

        <div className="flex header-item">
          <strong className="text-muted m-r-12">Status: </strong>
          <strong
            className={`${archivedStatuses.includes(project.projectStatusId) ? 'text-muted' : ''}`}
          >
            {project.status}
          </strong>
        </div>
        {isShowStrategyData ? (
          <React.Fragment>
            <VerticalSeparator />
            <div className="flex header-item">
              <strong className="text-muted m-r-12">
                {getOrgTermsContent('projectImpact')}:{' '}
              </strong>
              <strong>
                <RatingLabel rating={project.impact} reverse />
              </strong>
            </div>
          </React.Fragment>
        ) : null}
      </div>
      {isShowStrategyData ? (
        <div className="flex header-row">
          <div className="flex header-item">
            <HandshakeBlueIcon />
            <strong className="text-muted m-r-12 m-l-8">Sponsor(s): </strong>
            {changeStrategy?.project_sponsors.length ? (
              <ShowMoreItemsHeader
                items={changeStrategy.project_sponsors}
                maxShowNumber={2}
              />
            ) : (
              '—'
            )}
          </div>
          <VerticalSeparator />
          <div className="flex header-item">
            <ResourcesBlueIcon />
            <strong className="text-muted m-r-12 m-l-8">Resource(s): </strong>
            {changeStrategy?.supporting_resources.length ? (
              <ShowMoreItemsHeader
                items={changeStrategy.supporting_resources}
                maxShowNumber={2}
              />
            ) : (
              '—'
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};
export default connect(mapStateToProps)(ProjectDetailsHeader);
